export const DEALERS_PER_PAGE = 3;
export const CHECKOUT_RADIO_BUTTON_NAME = 'checkoutDealerRadioButton';
export const CURRENT_ITEMS_FIELD_SEPARATOR = '{current}';
export const TOTAL_ITEMS_FIELD_SEPARATOR = '{total}';
export const ACTIVE_DEALER_SESSION_KEY = 'checkout_active_dealer';
export const DEALER_LIST_TEST_ID = 'checkout_preferredDealer_list';
export const COUNT_LABEL = '{count}';
